import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Label, Row } from 'reactstrap';
import userManager from "../utils/userManager";
import Page from './Page';
import { setIsHome } from '../redux/MiscSlice';
import { useAppDispatch } from '../hooks/index';


const Login = () => {
    const dispatch = useAppDispatch();
    dispatch(setIsHome(true));

    const onLoginButtonClick = (event: React.MouseEvent<any, MouseEvent>) => {
        event.preventDefault();
        userManager.signinRedirect();
    }

    return (
        <React.Fragment>
            <Row className=" " style={{ height:"5vh" }} >
                <Col md="12" className="flex" >
                   
                </Col>
            </Row>
            <div className=" " style={{ background: "rgba(0, 0, 0, 0.5)", height:"65vh"}}>
                <Row className=" " style={{ color: "white", textAlign: "center", height:"7vh" }} >
                    <Col md="12" className="flex" >
                        <Label style={{ color: "white", fontSize: "4em" }}>Florida Open Financial Statement System</Label>
                    </Col>
                </Row>
                <br />
                <br />
                <Row className="flex align-items-center justify-content-center " style={{ height: "51vh" }} >
                    <Col className="flex" style={{ }}>
                        <div className="flex align-items-center justify-content-center" style={{ textAlign: "center" }}>
                            <h4 style={{ color: "white" }}>Citizens Enter Here to View Local Government Financial Data</h4>
                            <br />
                            <br />
                            <Link to={"/PublicReportsMenu"} >
                                <Button style={{
                                    marginLeft: '1em',
                                    borderRadius: '1em',
                                    textAlign: 'center',
                                    height: '5em',
                                    width: '30em',
                                    marginBottom: '2em',
                                    justifySelf: "center",
                                    alignSelf: "center",
                                    backgroundColor: '#0F5BA8'
                                }}>
                                    <h4 ><i className={"bi bi-search"} style={{ fontSize: '1.5rem' }}></i>{" SEARCH FINANCIAL DATA"}</h4>
                                </Button>
                            </Link>
                        </div>
                    </Col>

                    
                    <span className="align-middle" style={{ borderRight: "solid 1px white", height: "51vh" }} ></span>
                   
                    
                    <Col className="flex" >
                        <div className="flex align-items-center justify-content-center" style={{ textAlign: "center" }}>
                            <h4 style={{ color: "white" }}>Users Log-in Here to Submit Review Local Government Financial Data</h4>
                            <br />
                            <br />
                            <Button onClick={onLoginButtonClick} style={{
                                marginLeft: '1em',
                                borderRadius: '1em',
                                textAlign: 'center',
                                height: '5em',
                                width: '30em',
                                marginBottom: '2em',
                                gridArea: "right",
                                justifySelf: "center",
                                alignSelf: "center",
                                backgroundColor: '#0F5BA8'
                            }}>
                                <span className="h4" >USER LOGIN</span>
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
            <Row className=" " style={{ height: "5vh" }} >
                <Col md="12" className="flex" >

                </Col>
            </Row>
           


        </React.Fragment>
    );
}

export default Login;